<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>系统参数</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>系统参数配置</span>
        </div>
        <el-form
          :model="form"
          ref="form"
          label-width="100px"
          :status-icon="true"
          @submit.native.prevent="submitForm('form')"
        >
          <el-divider content-position="left">公司信息</el-divider>
          <el-form-item
            label="系统名称"
            prop="sysName"
            :rules="[{ required: true, message: '请输入系统名称' }]"
          >
            <el-input
              v-model="form.sysName"
              placeholder="请输入系统名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司名称"
            prop="comName"
            :rules="[{ required: true, message: '请输入公司名称' }]"
          >
            <el-input
              v-model="form.comName"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="信用代码"
            prop="comCode"
            :rules="[{ required: true, message: '请输入信用代码' }]"
          >
            <el-input
              v-model="form.comCode"
              placeholder="请输入信用代码"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司地址"
            prop="comSite"
            :rules="[{ required: true, message: '请输入公司地址' }]"
          >
            <el-input
              v-model="form.comSite"
              placeholder="请输入公司地址"
            ></el-input>
          </el-form-item>
          <el-form-item
          label="距离"
          prop="distance"
          :rules="[{ required: true, message: '请输入记录' }]"
        >
          <el-input
            v-model.number="form.distance"
            placeholder="请输入打卡距离"
          ></el-input>
        </el-form-item>
          <el-form-item
            label="现住地址"
            prop="realSite"
            :rules="[{ required: true, message: '请输入现住地址' }]"
          >
            <el-input
              v-model="form.realSite"
              placeholder="请输入现住地址"
            ></el-input>
          </el-form-item>
          <el-divider content-position="left">负责人</el-divider>
          <el-form-item
            label="负责人"
            prop="linkName"
            :rules="[{ required: true, message: '请输入邮箱' }]"
          >
            <el-input
              v-model="form.linkName"
              placeholder="请输入邮箱"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮箱"
            prop="email"
            :rules="[
              { required: true, message: '请输入邮箱' },
              { type: 'email', message: '邮箱格式不正确' },
            ]"
          >
            <el-input
              v-model="form.email"
              placeholder="请输入公司名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile" :rules="[]">
            <el-input
              v-model="form.mobile"
              placeholder="请输入手机号"
            ></el-input>
          </el-form-item>

          <!-- <el-form-item
            label="热搜词"
            prop="searchKeys"
            :rules="[{ required: true, message: '热搜词' }]"
          >
            <el-input
              v-model="form.searchKeys"
              placeholder="请输入关键词，使用逗号隔开"
            ></el-input>
          </el-form-item> 
          <el-divider content-position="left">小程序分享</el-divider>
          <el-form-item
            label="分享标题"
            prop="shareTitle"
            :rules="[{ required: true, message: '请输入分享标题' }]"
          >
            <el-input
              v-model="form.shareTitle"
              placeholder="请输入小程序首页分享标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="分享卡片">
            <div id="uploadBtnConfig" class="uploader uploader-warning"></div>
            <img
              id="relativeName"
              :src="domain + form.shareImg"
              style="height: 40px; position: relative; left: 10px; top: 20px"
              v-if="form.shareImg"
            />
            <span class="red">*注：图片比例要求：5:4 ，推荐尺寸：700*560</span>
          </el-form-item>-->

          <el-divider content-position="left">收款信息</el-divider>
          <el-form-item prop="rechargeParam" label="公司公户">
            <el-button type="success" size="mini" @click="bankVisiable = true"
              >点击管理</el-button
            >
          </el-form-item>
          <el-form-item prop="rechargeParam" label="其他账户">
            <el-button
              type="success"
              size="mini"
              @click="bankOtherVisiable = true"
              >点击管理</el-button
            >
          </el-form-item>
          <el-divider content-position="left">生活信息</el-divider>
          <el-form-item prop="rechargeParam" label="收货地址">
            <el-button type="success" size="mini" @click="reciveVisiable = true"
              >点击管理</el-button
            >
          </el-form-item>
          <el-form-item prop="rechargeParam" label="执照图片">
            <el-button
              type="success"
              size="mini"
              @click="licenseVisiable = true"
              >点击管理</el-button
            >
          </el-form-item>

          <el-divider content-position="left">财务信息</el-divider>
          <el-form-item prop="rechargeParam" label="财务账户">
            <el-button
              type="success"
              size="mini"
              @click="financialVisiable = true"
              >点击管理</el-button
            >
          </el-form-item>

          <el-form-item>
            <el-button type="primary" :loading="submiting" native-type="submit"
              >提交并保存</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
    </div>

    <!-- 公司公户 -->
    <el-dialog title="公户管理" :visible.sync="bankVisiable">
      <el-form
        label-width="100px"
        :status-icon="true"
        label-position="top"
        size="mini"
      >
        <div class="myrow" v-for="(item, index) in bankList" :key="index">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="银行账户">
                <el-input
                  type="text"
                  v-model="item.bankName"
                  placeholder="请输入账户名称"
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-close"
                    @click="delBankClick(index)"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号">
                <el-input
                  type="text"
                  v-model="item.bankAccount"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="开户行名称">
                <el-input
                  type="text"
                  v-model="item.bankFullName"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行编号">
                <el-input
                  type="text"
                  v-model="item.bankCode"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系方式">
                <el-input
                  type="text"
                  v-model="item.linkWay"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注">
                <el-input
                  type="text"
                  v-model="item.summary"
                  placeholder="请输入"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div style="height: 15px"></div>
          <el-button type="success" @click="addBankClick">追加</el-button>
          <el-button type="primary" @click="saveBank()">确 定</el-button>
          <el-button @click="bankVisiable = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 其他账户 -->
    <el-dialog title="其他账户" :visible.sync="bankOtherVisiable">
      <el-form
        label-width="100px"
        :status-icon="true"
        label-position="top"
        size="mini"
      >
        <div class="myrow" v-for="(item, index) in bankOtherList" :key="index">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="银行账户">
                <el-input
                  type="text"
                  v-model="item.bankName"
                  placeholder="请输入银行账户"
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-close"
                    @click="delBankOtherClick(index)"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="银行账号">
                <el-input
                  type="text"
                  v-model="item.bankAccount"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="开户行名称">
                <el-input
                  type="text"
                  v-model="item.bankFullName"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户行编号">
                <el-input
                  type="text"
                  v-model="item.bankCode"
                  placeholder="请输入开户行"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="二维码地址">
                <el-input
                  type="text"
                  v-model="item.qrCode"
                  placeholder="请输入图片连接"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div style="height: 15px"></div>
          <el-button type="success" @click="addBankOtherClick">追加</el-button>
          <el-button type="primary" @click="saveBankOther()">确 定</el-button>
          <el-button @click="bankOtherVisiable = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 收货地址 -->
    <el-dialog title="收货地址" :visible.sync="reciveVisiable">
      <el-form
        label-width="100px"
        :status-icon="true"
        label-position="top"
        size="mini"
      >
        <div class="myrow" v-for="(item, index) in reciveList" :key="index">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="联系人">
                <el-input
                  type="text"
                  v-model="item.realName"
                  placeholder="请输入联系人"
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-close"
                    @click="delReciveClick(index)"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系电话">
                <el-input
                  type="text"
                  v-model="item.mobile"
                  placeholder="请输入手机号"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="详细地址">
                <el-input
                  type="text"
                  v-model="item.address"
                  placeholder="请输入详细地址"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div style="height: 15px"></div>
          <el-button type="success" @click="addReciveClick">追加</el-button>
          <el-button type="primary" @click="saveRecive()">确 定</el-button>
          <el-button @click="reciveVisiable = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 执照资料 -->
    <el-dialog title="执照资料" :visible.sync="licenseVisiable">
      <el-form
        label-width="100px"
        :status-icon="true"
        label-position="top"
        size="mini"
      >
        <div class="myrow" v-for="(item, index) in licenseList" :key="index">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="证件名称">
                <el-input
                  type="text"
                  v-model="item.title"
                  placeholder="请输入证件名称"
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-close"
                    @click="delLicenseClick(index)"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="图片地址">
                <el-input
                  type="text"
                  v-model="item.imgUrl"
                  placeholder="请输入图片地址"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div style="height: 15px"></div>
          <el-button type="success" @click="addLicenseClick">追加</el-button>
          <el-button type="primary" @click="saveLicense()">确 定</el-button>
          <el-button @click="licenseVisiable = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 财务信息 -->
    <el-dialog title="财务信息" :visible.sync="financialVisiable">
      <el-form
        label-width="100px"
        :status-icon="true"
        label-position="top"
        size="mini"
      >
        <div class="myrow" v-for="(item, index) in financialList" :key="index">
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="平台类型">
                <el-input
                  type="text"
                  v-model="item.typeName"
                  placeholder="请输入账号类型"
                >
                  <el-button
                    slot="prepend"
                    icon="el-icon-close"
                    @click="delFinancialClick(index)"
                  ></el-button>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="平台连接">
                <el-input
                  type="text"
                  v-model="item.link"
                  placeholder="请输入连接地址"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item label="账号">
                <el-input
                  type="text"
                  v-model="item.account"
                  placeholder="请输入账号"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="密码">
                <el-input
                  type="text"
                  v-model="item.pwd"
                  placeholder="请输入密码"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="备注">
                <el-input
                  type="text"
                  v-model="item.summary"
                  placeholder="请输入备注"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <el-form-item>
          <div style="height: 15px"></div>
          <el-button type="success" @click="addFinancialClick">追加</el-button>
          <el-button type="primary" @click="saveFinancial()">确 定</el-button>
          <el-button @click="financialVisiable = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
export default {
  data() {
    return {
      submiting: false,
      domain: url.getDomain(),
      form: {}, //参数对象
      bankVisiable: false, //公户
      bankList: [],
      bankOtherVisiable: false, //其他账户
      bankOtherList: [],
      reciveVisiable: false, //收货地址
      reciveList: [],
      licenseVisiable: false, //执照图片
      licenseList: [],
      financialVisiable: false, //财务信息
      financialList: [],
      list: [],
    };
  },
  methods: {
    //获取配置信息
    getConfig: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      var link = url.getBaseData("getconfig");
      $.get(link, params, (data) => {
        if (data.bankList) {
          _this.bankList = JSON.parse(data.bankList);
        } else {
          _this.bankList = [];
        }
        if (data.bankOtherList) {
          _this.bankOtherList = JSON.parse(data.bankOtherList);
        } else {
          _this.bankOtherList = [];
        }
        //收货地址
        if (data.reciveList) {
          _this.reciveList = JSON.parse(data.reciveList);
        } else {
          _this.reciveList = [];
        }
        //执照图片
        if (data.licenseList) {
          _this.licenseList = JSON.parse(data.licenseList);
        } else {
          _this.licenseList = [];
        }
        //财务账户
        if (data.financialList) {
          _this.financialList = JSON.parse(data.financialList);
        } else {
          _this.financialList = [];
        }

        _this.loading = false;
        _this.form = data;
      });
    },
    /********* 公户账户 *******/
    // 添加公户
    addBankClick: function () {
      this.bankList.push({});
    },
    // 删除公户
    delBankClick: function (index) {
      this.bankList.splice(index, 1);
    },
    //保存
    saveBank() {
      var _this = this;
      _this.bankVisiable = false;
      var list = [];
      _this.bankList.forEach((element) => {
        if (element.bankName) {
          list.push(element);
        }
      });
      _this.form.bankList = JSON.stringify(list);
    },
    /********* 其他账户 *******/
    // 添加
    addBankOtherClick: function () {
      this.bankOtherList.push({});
    },
    // 删除
    delBankOtherClick: function (index) {
      this.bankOtherList.splice(index, 1);
    },
    //保存
    saveBankOther() {
      var _this = this;
      _this.bankOtherVisiable = false;
      var list = [];
      _this.bankOtherList.forEach((element) => {
        if (element.bankName) {
          list.push(element);
        }
      });
      _this.form.bankOtherList = JSON.stringify(list);
    },
    /********* 收货地址 *******/
    // 添加
    addReciveClick: function () {
      this.reciveList.push({});
    },
    // 删除
    delReciveClick: function (index) {
      this.reciveList.splice(index, 1);
    },
    //保存
    saveRecive() {
      var _this = this;
      _this.reciveVisiable = false;
      var list = [];
      _this.reciveList.forEach((element) => {
        if (element.realName) {
          list.push(element);
        }
      });
      _this.form.reciveList = JSON.stringify(list);
    },
    /********* 执照图片 *******/
    // 添加
    addLicenseClick: function () {
      this.licenseList.push({});
    },
    // 删除
    delLicenseClick: function (index) {
      this.licenseList.splice(index, 1);
    },
    //保存
    saveLicense() {
      var _this = this;
      _this.licenseVisiable = false;
      var list = [];
      _this.licenseList.forEach((element) => {
        if (element.title) {
          list.push(element);
        }
      });
      _this.form.licenseList = JSON.stringify(list);
    },
    /********* 财务信息 *******/
    // 添加
    addFinancialClick: function () {
      this.financialList.push({});
    },
    // 删除
    delFinancialClick: function (index) {
      this.financialList.splice(index, 1);
    },
    //保存
    saveFinancial() {
      var _this = this;
      _this.financialVisiable = false;
      var list = [];
      _this.financialList.forEach((element) => {
        if (element.typeName) {
          list.push(element);
        }
      });
      _this.form.financialList = JSON.stringify(list);
    },

    //提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getBaseData("saveconfig");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //添加或者修改
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 上传图片
    initImg: function () {
      var _this = this;
      if ($("#uploadBtnConfig input").length == 0) {
        $("#uploadBtnConfig").uploader({
          url: url.getUpload(),
          text: "上传图片",
          fileExts: "jpg;png",
          handleType: "0",
          maxSize: 1024 * 1024 * 0.5,
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "shareImg", data.relativeName);
          },
        });
      }
    },
  },
  mounted() {
    //获取服务器列表
    this.getConfig();
    //this.initImg();
  },
};
</script>

<style scoped>
.myrow {
  border-bottom: 1px solid rgb(178, 113, 243);
  padding-top: 10px;
}
/* .query-form {
  margin-top: 20px;
  padding-top: 25px;
  background: #f2f2f2;
}
.el-form-item--small.el-form-item {
  margin-right: 0px;
}

.el-button--primary {
  margin-left: 10px;
}*/
.el-divider--horizontal {
  margin-top: 40px;
}
.el-divider__text.is-left {
  color: #409eff;
}
.red {
  color: red;
  font-size: 12px;
  position: relative;
  left: 15px;
}
</style>
